/**
 * Admin Dashboard Page
 *
 * Landing page for administrative tools. Links out to the
 * individual admin areas (e.g. Manage Users).
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Col, Row, Typography } from 'antd';
import { ChevronRight, Users } from 'lucide-react';

import { ROUTES } from '@/routes';
import styles from './Admin.module.scss';

const { Title, Text } = Typography;

interface AdminTool {
  key: string;
  title: string;
  description: string;
  icon: React.ReactNode;
  route: string;
}

const ADMIN_TOOLS: AdminTool[] = [
  {
    key: 'users',
    title: 'Manage Users',
    description: 'View, invite, and manage everyone with access to this application.',
    icon: <Users style={{ width: '1em', height: '1em' }} />,
    route: ROUTES.ADMIN_USERS,
  },
];

export const Admin: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <Title level={2} className={styles.title}>
          Admin Dashboard
        </Title>
        <Text type="secondary" className={styles.pageSub}>
          Manage your application's settings and access.
        </Text>
      </div>

      <Row gutter={[24, 24]}>
        {ADMIN_TOOLS.map((tool) => (
          <Col key={tool.key} xs={24} sm={12} lg={8}>
            <Card
              hoverable
              className={styles.toolCard}
              onClick={() => navigate(tool.route)}
            >
              <div className={styles.toolIcon}>{tool.icon}</div>
              <div className={styles.toolBody}>
                <Text strong className={styles.toolTitle}>
                  {tool.title}
                </Text>
                <Text type="secondary" className={styles.toolDescription}>
                  {tool.description}
                </Text>
              </div>
              <ChevronRight className={styles.toolArrow} style={{ width: '1em', height: '1em' }} />
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Admin;
